import {
  TreemapGroupSelectEvent,
  useAnalyzeClustering,
} from '@/features/analyze/hooks/useAnalyzeClustering';
import { useEffect, useRef } from 'react';
// @ts-expect-error 型定義がないので一旦無視する
import { FoamTree as FoamTreeImpl } from '@carrotsearch/foamtree';

const foamTreeOption = {
  pixelRatio: window.devicePixelRatio || 1,
  relaxationVisible: true,
  groupBorderWidth: 1,
  groupBorderWidthScaling: 0.4,
  rolloutEasing: 'squareInOut',
  rolloutScalingStrength: -0.3,
  rolloutRotationStrength: 0,
  pullbackEasing: 'squareInOut',
  pullbackScalingStrength: -0.3,
  pullbackRotationStrength: 0,
  pullbackPolygonDelay: 0.1,
  fadeDuration: 0,
  groupFillType: 'plain',
};

export type GroupItem = {
  id: string;
  label: string;
};

type FoamTreeViewProps = {
  data: ReturnType<typeof useAnalyzeClustering>['formattedTreemapData'];
  onSelectTarget: (e: TreemapGroupSelectEvent) => void;
};

export const FoamTreeView = ({ data, onSelectTarget }: FoamTreeViewProps) => {
  const element = useRef<HTMLDivElement>(null);
  const onSelectTargetRef = useRef(onSelectTarget);
  const foamtree = useRef<{
    set: (key: string, value: unknown) => void;
    resize: () => void;
    dispose: () => void;
  } | null>(null);

  // onGroupDoubleClick は初回登録だけにして、最新ハンドラは ref 経由で参照する。
  // これにより useCallback に依存せず、FoamTree への再登録も避けられる。
  useEffect(() => {
    onSelectTargetRef.current = onSelectTarget;
  }, [onSelectTarget]);

  useEffect(() => {
    if (!element.current) return;

    const instance = new FoamTreeImpl({
      ...foamTreeOption,
      element: element.current,
      dataObject: { groups: [] },
    });
    instance.set('onGroupDoubleClick', (event: TreemapGroupSelectEvent) => {
      onSelectTargetRef.current(event);
    });
    foamtree.current = instance;

    const handleResize = () => instance.resize();
    window.addEventListener('orientationchange', handleResize);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('orientationchange', handleResize);
      window.removeEventListener('resize', handleResize);
      instance.dispose();

      if (foamtree.current === instance) {
        foamtree.current = null;
      }
    };
  }, []);

  useEffect(() => {
    foamtree.current?.set('dataObject', { groups: data });
  }, [data]);

  return <div id="visualization" ref={element} className="size-full"></div>;
};
